/**
 * The Jottacloud Android WebView replaces the user agent with
 * JOTTACLOUD/<version> Android/<os> <applicationId> <versionCode>.
 * Other brands use their own prefix.
 */
export function isJottacloudAndroidApp(userAgent: string) {
  const parts = userAgent.toLowerCase().split(' ')
  return (
    parts.some(part => part.startsWith('jottacloud/')) &&
    parts.some(part => part.startsWith('android/'))
  )
}
